import { registerBlockType } from '@wordpress/blocks';
import {RichText, MediaUpload, InspectorControls, InnerBlocks} from '@wordpress/block-editor';
import {Button, PanelBody} from '@wordpress/components';


registerBlockType('meetravel/hero-block', {
    title: 'Hero Block',
    icon: 'superhero-alt',
    category: 'layout',
    attributes: {
        title: {
            type: 'string',
            source: 'html',
            selector: 'h1',
        },
        firstParagraph: {
            type: 'string',
            source: 'html',
            selector: 'p.first-paragraph',
        },
        secondParagraph: {
            type: 'string',
            source: 'html',
            selector: 'p.second-paragraph',
        },
        imageUrl: {
            type: 'string',
            source: 'attribute',
            selector: 'img',
            attribute: 'src',
        },
        backgroundMedia: {
            type: 'object',
            default: {
                url: '',
                type: '',
            },
        },
    },

    edit(props) {
        const { attributes, setAttributes } = props;
        const { title, firstParagraph, secondParagraph, imageUrl, backgroundMedia } = attributes;

        function updateAttribute(attr, value) {
            props.setAttributes({ [attr]: value });
        }

        function onSelectImage(media) {
            props.setAttributes({ imageUrl: media.url });
        }

        const setBackgroundMedia = (media) => {
            setAttributes({
                backgroundMedia: {
                    url: media.url,
                    type: media.type,
                }
            })
        }

        return (
            <section className="hero">
                <InspectorControls>
                    <PanelBody title="Background">
                        <MediaUpload
                            onSelect={(media) => setBackgroundMedia(media)}

                            allowedTypes={['image', 'video']}
                            render={({ open }) => (
                                <Button onClick={open} variant="primary">
                                    {'Seleziona Media'}
                                </Button>
                            )}
                        />
                        {backgroundMedia.url && backgroundMedia.type === 'image' && (
                            <img src={backgroundMedia.url} alt="Seleziona immagine" style={{ maxWidth: '100%' }} />
                        )}
                        {backgroundMedia.url && backgroundMedia.type === 'video' && (
                            <video src={backgroundMedia.url} controls style={{ maxWidth: '100%' }} />
                        )}
                    </PanelBody>
                </InspectorControls>

                {backgroundMedia.url && backgroundMedia.type === 'image' && (
                    <div  className="hero-background-container">
                       <img className={'hero-background-media hero background-image'} src={backgroundMedia.ur} alt={'background-media'}/>
                    </div>
                )}
                {backgroundMedia.url && backgroundMedia.type === 'video' && (
                    <div  className="hero-background-container">
                        <video className="hero-background-media hero-background-video" autoPlay loop muted>
                            <source src={backgroundMedia.url} type="video/mp4" />
                        </video>
                    </div>
                )}

                <div className="background-overlay"></div>
                <article className="hero-article left-hero">
                    <RichText
                        tagName="h1"
                        value={title}
                        onChange={(value) => updateAttribute('title', value)}
                        placeholder="The Hero Title"
                    />
                    <RichText
                        tagName="p"
                        className="first-paragraph"
                        value={firstParagraph}
                        onChange={(value) => updateAttribute('firstParagraph', value)}
                        placeholder="First Paraggraph"

                    />
                    <RichText
                        tagName="p"
                        className="second-paragraph"
                        value={secondParagraph}
                        onChange={(value) => updateAttribute('secondParagraph', value)}
                        placeholder="Second Paraggraph"
                    />
                    <InnerBlocks allowedBlocks={["meetravel/store-buttons"]}/>
                </article>
                <article className="hero-article right-hero">
                    <div className="bubble-container">
                        <div className="pill">
                                <MediaUpload
                                    onSelect={onSelectImage}
                                    allowedTypes='image'
                                    value={imageUrl}
                                    render={({ open }) => (
                                        <Button onClick={open}>
                                            {!imageUrl ? 'Select Image' : <img src={imageUrl} alt='Hero Image' />}
                                        </Button>
                                    )}
                                />
                        </div>
                    </div>
                </article>
            </section>
        );
    },

    save({ attributes }) {
        const { title, firstParagraph, secondParagraph, imageUrl, backgroundMedia } = attributes;
        return (
            <section className="hero">
                {backgroundMedia.url && backgroundMedia.type === 'image' && (
                    <div className="hero-background-container">
                        <img className={'hero-background-media hero background-image'} src={backgroundMedia.url} alt={'background-media'} />
                    </div>
                )}
                {backgroundMedia.url && backgroundMedia.type === 'video' && (
                    <div className="hero-background-container">
                        <video className="hero-background-media hero-background-video" autoPlay loop muted>
                            <source src={backgroundMedia.url} type="video/mp4" />
                        </video>
                    </div>
                )}
                <div className="background-overlay"></div>
                <article className="hero-article left-hero">
                    <RichText.Content tagName="h1" value={title} />
                    <RichText.Content tagName="p" className="first-paragraph" value={firstParagraph} />
                    <RichText.Content tagName="p" className="second-paragraph" value={secondParagraph} />
                    <InnerBlocks.Content/>
                </article>
                <article className="hero-article right-hero">
                    <div className="bubble-container">
                        <div className="pill">
                            <img src={imageUrl} alt='Hero Image' />
                        </div>
                    </div>
                </article>
            </section>
        );
    }
    ,
});
